import { ICON__maximize2 } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { useReactFlow } from '@xyflow/react'; // Assuming standard xyflow hooks

export function G_BUTTON__graph_fit_view() {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { fitView } = useReactFlow();

  /*
   * EVENTS
   */
  async function onClick() {
    fitView({ padding: 0.2, duration: 300 });
  }
  /*
   * METHODS
   */

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_10_5 />;
  if (generation_current.tool.graph.nodes_map.size() < 2) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <UI_PRIMITIVE__button size="rect-10-6" variant={'no-border-on-component'} {...{ onClick }}>
      <ICON__maximize2 className="size-3" />
    </UI_PRIMITIVE__button>
  );
}
